import { render, staticRenderFns } from "./SceneDetail.vue?vue&type=template&id=db07b62e&scoped=true&"
import script from "./SceneDetail.vue?vue&type=script&lang=js&"
export * from "./SceneDetail.vue?vue&type=script&lang=js&"
import style0 from "./SceneDetail.vue?vue&type=style&index=0&id=db07b62e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db07b62e",
  null
  
)

export default component.exports